<template>
    <div class="MyComments-row">
        <div class="Comments-row">
            <div class="MyComments-img">
                <a :href="$store.state.hrefPrefix + '/articles/' + comment.article.slug"><img :src="comment.article.blob.url" alt=""></a>
            </div>
            <div class="MyComments-content">
                <h2><a :href="$store.state.hrefPrefix + '/category/' + comment.article.category.slug">{{
                        comment.article.category.category_languages[0].pivot.name
                    }}</a></h2>
                <h3><a :href="$store.state.hrefPrefix + '/articles/' + comment.article.slug">{{
                        comment.article.article_languages[0].pivot.title
                    }}</a>
                </h3>
            </div>
        </div>
        <p>{{ comment.text }}</p>
        <input type="hidden" name="_token" :value="csrf">
        <ul>
            <li>{{ formattedCreatedAt }}</li>

            <li class="Delete-click" @click="isDeleting = true"><img src="/assets/images/remove-icon.svg" alt="">{{ $t('delete') }}</li>

        </ul>
        <div class="Delete-Comment" :class="{'active': isDeleting}">
            <div class="Delete-Comment-row">
                <p>{{ $t('delete_comment') }} </p>
                <span>{{ $t('you_are_about_to_delete') }}</span>
                <div class="Delete-Comment-btn">
                    <button class="nokeep" @click="isDeleting = false">{{ $t('cap_no_keep') }}</button>
                    <button @click="deleteComment">{{ $t('cap_yes_delete') }} </button>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "MyCommentsListing",
    props: {
        comment: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            isDeleting: false
        };
    },
    methods: {
        deleteComment() {
            window.location.href = '/comment/' + this.comment.id + '/delete'
        }
    },
    computed: {
        formattedCreatedAt() {
            const date = new Date(this.comment.article.created_at.replace(' ', 'T'));
            const options = {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            };
            return date.toLocaleString(this.$store.state.language.code === 'ar' ? 'ar-LB' : 'en-US', options).toUpperCase();
        }
    }

}
</script>

<style scoped>

</style>
